export const viewUtilsActionTypes={
    SET_BREAD_CRUMBS_INDEX:"SET_BREAD_CRUMBS_INDEX",
    SET_DATA_GRID_INDEX:"SET_DATA_GRID_INDEX",
    SET_DRAWER_STATUS:"SET_DRAWER_STATUS",
}

